import React from 'react'
import MainContainerStyle from "./MainContainerStyle.module.css"
//import components
import SideBar from "./SideBar"
import ShowBar from './ShowBar'


const MainContainer = () => {
    return (
        <div className={MainContainerStyle.container}>
          <SideBar/>
          <ShowBar/> 
            
        </div>
    )
}

export default MainContainer
